// extracted by mini-css-extract-plugin
export var disabled = "_n-a";
export var hierarchyLinkGray = "_n-4";
export var hierarchyLinkUnderline = "_n-3";
export var hierarchyPrimary = "_n-0";
export var hierarchySecondary = "_n-1";
export var hierarchyTertiary = "_n-2";
export var pressed = "_n-6";
export var themeAction = "_n-5";
export var themeDestructive = "_n-8";
export var themeNormal = "_n-7";
export var themeSuccess = "_n-9";